import Badge from 'components/badge/badge';
import { rowKindOf } from 'constants/taskTypes';
import useText from 'hooks/useText';

// What a row is, in the colour of its badge: « Tâche », or « Rendez-vous » and
// « Rappel » for an appointment or a callback ticked on the home page. A task
// stored with an old type (call, e-mail…) reads as a plain task.
const TaskTypeBadge = ({ row }) => {
  const { text } = useText('tasks');
  const kind = rowKindOf(row.kind);
  return <Badge type={kind.badge}>{text(kind.label)}</Badge>;
};

export default TaskTypeBadge;
